export const VALIDACAO_INICIAL = {
    nome: {
        id: '',
        mensagem: '',
        error: false
    },
    cpf: {
        id: '',
        mensagem: '',
        error: false
    },
    email: {
        id: '',
        mensagem: '',
        error: false
    },
    celular: {
        id: '',
        mensagem: '',
        error: false
    },
    senha: {
        id: '',
        mensagem: '',
        error: false
    },
    termoAceite: {
        id: '',
        mensagem: '',
        error: false
    },
    nascimento: {
        id: '',
        mensagem: '',
        error: false
    },
}